import React from "react";
import styles from "./LocationPlaceholder.module.css";

interface LocationPlaceholderProps {
  onClick?: () => void;
}

export const LocationPlaceholder: React.FC<LocationPlaceholderProps> = ({
  onClick,
}) => {
  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.icon}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_5038_5369)">
            <path
              d="M10 10.625V6.25M12.8477 2.5H7.15234C7.07024 2.49994 6.98894 2.51605 6.91306 2.54741C6.83719 2.57878 6.76824 2.62479 6.71016 2.68281L2.68281 6.71016C2.62479 6.76824 2.57878 6.83719 2.54741 6.91306C2.51605 6.98894 2.49994 7.07024 2.5 7.15234V12.8477C2.49994 12.9298 2.51605 13.0111 2.54741 13.0869C2.57878 13.1628 2.62479 13.2318 2.68281 13.2898L6.71016 17.3172C6.76824 17.3752 6.83719 17.4212 6.91306 17.4526C6.98894 17.484 7.07024 17.5001 7.15234 17.5H12.8477C12.9298 17.5001 13.0111 17.484 13.0869 17.4526C13.1628 17.4212 13.2318 17.3752 13.2898 17.3172L17.3172 13.2898C17.3752 13.2318 17.4212 13.1628 17.4526 13.0869C17.484 13.0111 17.5001 12.9298 17.5 12.8477V7.15234C17.5001 7.07024 17.484 6.98894 17.4526 6.91306C17.4212 6.83719 17.3752 6.76824 17.3172 6.71016L13.2898 2.68281C13.2318 2.62479 13.1628 2.57878 13.0869 2.54741C13.0111 2.51605 12.9298 2.49994 12.8477 2.5Z"
              stroke="#8C8A92"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.0003 14.8334C10.4606 14.8334 10.8337 14.4603 10.8337 14.0001C10.8337 13.5398 10.4606 13.1667 10.0003 13.1667C9.54009 13.1667 9.16699 13.5398 9.16699 14.0001C9.16699 14.4603 9.54009 14.8334 10.0003 14.8334Z"
              fill="#8C8A92"
            />
          </g>
          <defs>
            <clipPath id="clip0_5038_5369">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <span className={styles.text}>Локация не указана</span>
      <span className={styles.link}>Уточнить на карте</span>
    </div>
  );
};
